module.exports = __webpack_public_path__ + "static/33328508-f087-48e8-8f4d-b93f678937d0-c7f1dd2f5ef238f0cbe712a3e78abdcc.jpeg";